<template>
  <div class="content">
    <div class="bannerWrap">
      <div class="topbanner EC_width display_between">
        <div class="bannerleft">
          <swiper v-if="topRotation.length > 0" :options="swiperOption" ref="mySwiper_info">
            <swiper-slide v-for="(item, index) in topRotation" :key="index">
              <!-- <img :src="item.resUrl" class="imgBanner"> -->
              <img :src="item.resUrl" class="imgBanner" style="border-radius: 20px 0px 0px 0px; cursor: pointer;"
                width="930" height="380" @click="Towindowurl(item.url)" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="bannerright">
          <swiper v-if="topRotation.length > 0" :options="swiperOption2" ref="mySwiper">
            <swiper-slide v-for="(item, index) in topRotation" :key="index" @click="Towindowurl(item.url)"
              :style="{ backgroundImage: 'url(' + item.resRightUrl + ')', backgroundSize: '100% 100%' }">
              <div>
                <img src="/image/index/index3tuceng.png" class="shan" />
                <div style="padding:40px 50px">
                  <div class="bannerTitle">{{ item.title }}</div>
                  <div class="bannerline"></div>
                  <div class="bannerText">
                    <span v-html="ellipsis(item.detail, 120)"></span>
                  </div>
                  <div class="marginTop20">
                    <a href="javascript:void(0);" @click="Towindowurl(item.url)" class="bannerBtn">了解更多</a>
                  </div>
                </div>

              </div>

            </swiper-slide>
          </swiper>

        </div>
      </div>
    </div>
    <div class="main display_between_nocenter EC_width" style="padding-bottom:10px">
      <div class="mainCenter flex1 marginRight50">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span v-for="(item, index) in columntopList" :key="index + '2'" class="tagTitle "
              :class="{ tagTitleActive: dynamicTagindex == index }" @click="tagDatadynamic(index, item.id)">
              {{ item.name }}
            </span>
          </div>
          <div class="gl_tb_right">
            <a href="javascript:;" class="gl_tb_right_more" @click="onMore(grastab, columntopList[dynamicTagindex].name)">
              <img src="/image/index/moreimg.png" class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>

        <div v-for="(item, index) in newInfotopList" :key="index + '3'">
          <div v-if="grastab == item.cid">
            <div class="gl_listWrapBar_nopad controlShow" style="margin: 20px 0;">
              <div class="gl_imgList setShow" @click="clkNews(item, columntopList[dynamicTagindex].name)">
                <img :src="item.slideShow" width="156" height="88" class="imgtran" />
              </div>
              <a href="javascript:;" class="gl_listItem display_column">
                <div class="gl_listItemTitle fontBold setShow"
                  @click="clkNews(item, columntopList[dynamicTagindex].name)">
                  {{ item.title }}
                </div>
                <div class="gl_listItemTitle disShow" style="line-height:10px;"
                  @click="clkNews(item, columntopList[dynamicTagindex].name)">
                  {{ item.title }}
                </div>
                <div class="gl_listItemTitle  setShow" @click="clkNews(item, columntopList[dynamicTagindex].name)">
                  {{ ellipsis(item.abstract, 40) }}
                </div>
                <div class="display_between  setShow">
                  <div>
                    <span v-bind:class="calculate(index)" v-for="(qitem, index) in (item.labelName || '').split(',')"
                      :key="index" @click="onsearch(qitem)">
                      {{ qitem }}
                    </span>
                  </div>
                  <div class="gl_inforshow ">
                    <span class="marginRight20">
                      {{ formatTime(item.publishtime, 'YYYY/MM/DD') }}
                    </span>
                    <span>
                      <img src="/image/index/chakan.png" />
                      {{ item.clickVolume }}
                    </span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="mainRight">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle">{{ jdwdh60 }}</span>
          </div>
          <div class="gl_tb_right">
            <a href="javascript:;" class="gl_tb_right_more" @click="onMore(microDialogueList[0].cid, jdwdh60)">
              <img src="/image/index/moreimg.png" class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div class="video_block marginTop13" v-for="(item, index) in microDialogueList" :key="index + '1'"
          @click="clkNews(item, jdwdh60)">
          <img :src="item.slideShow" width="300" height="169" class="imgtran" />
          <div class="video_title">
            {{ ellipsis(item.title, 17) }}
          </div>
        </div>
      </div>
    </div>
    <KeCheng labelName="学科建设" newlabelName="全科课堂"></KeCheng>
    <div class="text_center" v-for="(item, index) in bottomRotation" :key="index" @click="Towindowurl(item.url)">
      <img :src="item.resUrl" class="imgtran" alt="" width="1200" height="110" />
    </div>
    <div class="main display_between_nocenter EC_width" style="padding-bottom:10px">
      <div class="mainCenter flex1 marginRight50">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span v-for="(item, index) in columnbonList" :key="index + '3'" class="tagTitle"
              :class="{ tagTitleActive: unionTagindex == index }" @click="tagDataunion(index, item.id)">
              {{ item.name }}
            </span>
          </div>
          <div class="gl_tb_right">
            <a href="javascript:;" class="gl_tb_right_more" @click="onMore(dynatab, columnbonList[unionTagindex].name)">
              <img src="/image/index/moreimg.png" class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div v-for="(item, index) in newInfolowerList" :key="index + '4'">
          <div v-if="dynatab == item.cid">
            <div class="gl_listWrapBar_nopad controlShow" style="margin: 20px 0;">
              <div class="gl_imgList setShow" @click="clkNews(item, columnbonList[unionTagindex].name)">
                <img :src="item.slideShow" width="156" height="88" class="imgtran" />
              </div>
              <a href="javascript:;" class="gl_listItem display_column">
                <div class="gl_listItemTitle fontBold setShow" @click="clkNews(item, columnbonList[unionTagindex].name)">
                  {{ item.title }}
                </div>
                <div class="gl_listItemTitle disShow" style="line-height:10px;"
                  @click="clkNews(item, columnbonList[unionTagindex].name)">
                  {{ item.title }}
                </div>
                <div class="gl_listItemTitle  setShow" @click="clkNews(item, columnbonList[unionTagindex].name)">
                  {{ ellipsis(item.abstract, 40) }}
                </div>
                <div class="display_between  setShow">
                  <div>
                    <span v-bind:class="calculate(index)" v-for="(qitem, index) in (item.labelName || '').split(',')"
                      :key="index" @click="onsearch(qitem)">
                      {{ qitem }}
                    </span>
                  </div>
                  <div class="gl_inforshow ">
                    <span class="marginRight20">
                      {{ formatTime(item.publishtime, 'YYYY/MM/DD') }}
                    </span>
                    <span>
                      <img src="/image/index/chakan.png" />
                      {{ item.clickVolume }}
                    </span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="mainRight">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle">{{ qkdjt }}</span>
          </div>
          <div class="gl_tb_right" @click="onMore(generalLectureList[0].cid, qkdjt)">
            <a href="javascript:;" class="gl_tb_right_more">
              <img src="/image/index/moreimg.png" class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div class="video_block marginTop20" v-for="(item, index) in generalLectureList" :key="index + '6'"
          @click="clkNews(item, qkdjt)">
          <img :src="item.slideShow" class="imgtran" width="300" height="169" />
          <div class="video_title">
            <span>{{ ellipsis(item.title, 17) }}</span>
          </div>
        </div>
      </div>
    </div>
    <KeCheng labelName="人才培养" newlabelName="教学课程"></KeCheng>
  </div>
</template>

<script>
import format from '@/assets/unit/unit.js';
import KeCheng from '../../components/kecheng';
export default {
  name: 'build',
  components: {
    KeCheng,
  },
  data() {
    return {
      apiData: {
        bannerImgList: {},
        dynamic: {},
        dialogue: {},
        union: {},
        forum: {}
      },
      // 学科动态切换
      dynamicTagindex: 0,
      // 青年联盟切换
      unionTagindex: 0,
      swiperOption: {
        loop: true,
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite',
          bulletActiveClass: 'bulletWriteActive',
          clickable: true
        },
        autoplay: {
          delay: 6000,
          disableOnInteraction: false
        },
        on: {
          slideChangeTransitionEnd: () => {
            const infoSwiper = this.$refs.mySwiper_info && this.$refs.mySwiper_info.swiper;
            const thumbSwiper = this.$refs.mySwiper && this.$refs.mySwiper.swiper;
            if (
              !infoSwiper ||
              !thumbSwiper ||
              !infoSwiper.slides ||
              !thumbSwiper.slides ||
              infoSwiper.slides.length === 0 ||
              thumbSwiper.slides.length === 0
            ) {
              return;
            }
            thumbSwiper.slideTo(infoSwiper.activeIndex, 200, false);
          },
        },
      },
      swiperOption2: {
        loop: true,
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite',
          bulletActiveClass: 'bulletWriteActive',
          clickable: true
        },
        autoplay: {
          delay: 6000,
          disableOnInteraction: false
        },

        on: {
          slideChangeTransitionEnd: () => {
            const infoSwiper = this.$refs.mySwiper_info && this.$refs.mySwiper_info.swiper;
            const thumbSwiper = this.$refs.mySwiper && this.$refs.mySwiper.swiper;
            if (
              !infoSwiper ||
              !thumbSwiper ||
              !infoSwiper.slides ||
              !thumbSwiper.slides ||
              infoSwiper.slides.length === 0 ||
              thumbSwiper.slides.length === 0
            ) {
              return;
            }
            infoSwiper.slideTo(thumbSwiper.activeIndex, 200, false);
          },
        },
      },
      /**tianlianpei */
      // 学科建设导航
      grastab: 58,
      grastabname: '学科动态12',
      dynatabname: '大学全科院系234',
      intocommuni: [
        {
          title: '学科建设1'
        },
        {
          title: '基地建设2'
        }
      ],
      // 大学全科院系导航
      dynatab: 61,
      dynauni: [
        {
          title: '大学全科院系'
        },
        {
          title: '青年联盟'
        }
      ],
      columnList: [],
      topRotation: [], //顶部轮播
      bottomRotation: [], //底部轮播
      columntopList: [], //学科动态,基地建设
      columnbonList: [], //大学全科院系，青年联盟
      columnJDWDHList: [], //基地微对话，
      columnGeneralList: [], // 全科大讲堂
      microDialogueList: [], //基地微对话
      generalLectureList: [], // 全科大讲堂
      newInfotopList: [], //学科建设，基地建设
      newInfolowerList: [], //大学全科院系，青年联盟
      colorList: ['gl_gree_block', 'gl_red_block', 'gl_blue_block'],
      jdwdh60: '',
      qkdjt: '',
    };
  },
  created() {
    this.GetRotationInfo();
    this.GetColumsInfoAllList();
  },
  methods: {
    onsearch(keywords) {
      const { href } = this.$router.resolve({
        path: '/home/searchPage?',
        query: {
          labelname: keywords
        }
      });
      window.open(href, '_blank');
    },
    calculate(index) {
      var nm = this.colorList[Math.floor(index % 3)];
      return nm;
    },
    tagDatadynamic(index, id) {
      // 学科动态0 基地建设1数据
      this.dynamicTagindex = index;
      this.grastab = id;
    },
    tagDataunion(index, id) {
      // 大学全科院系0 青年联盟1
      this.unionTagindex = index;
      this.dynatab = id;
    },
    /**tianlianpei */
    /**获取轮播数据 */
    GetRotationInfo() {
      let _this = this;
      let arr = [9, 14]; //分别代表学科建设轮播，底部
      for (let i = 0; i < arr.length; i++) {
        _this.httphelper
          .post('/api/WebSetMessApi/GetRotationInfo', {
            type: arr[i],
            ruselocation: 1,
            source: 2
          })
          .then(res => {
            console.log(res.data.data,'-------');
            if (res.data.code == 200) {
              if (arr[i] == 9) {
                _this.topRotation = res.data.data || [];
              }
              if (arr[i] == 14) {
                _this.bottomRotation = res.data.data || [];
              }
            }
          });
      }
    },
    /**获取栏目数据 */
    GetColumsInfoAllList() {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetColumsInfoAllList', {
          cType: 1,
          isCHorEN: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            let data = res.data.data.sort(function (a, b) {
              return a.sort - b.sort;
            });
            data.forEach(item => {
              if (item.id >= 58 && item.id <= 59) {
                //学科动态,基地建设
                _this.columntopList.push(item);
              }
              if (item.id >= 61 && item.id <= 62) {
                //大学全科院系，青年联盟
                _this.columnbonList.push(item);
              }
              if (item.id == 60) {
                //基地微对话，
                _this.columnJDWDHList.push(item);
                _this.jdwdh60 = item.name;
              }
              if (item.id == 63) {
                // 全科大讲堂
                _this.columnGeneralList.push(item);
                _this.qkdjt = item.name;
              }
              if (item.id >= 58 && item.id <= 63) {
                _this.columnList.push(item);
              }
            });
            //获取首页热门内容数据
            _this.GetGpSiteNewInfoPageList();
          }
        });
    },
    /**获取首页中部新闻信息 */
    GetGpSiteNewInfoPageList() {
      let _this = this;
      let column = _this.columnList;
      let pagesize = 14;
      for (let i = 0; i < column.length; i++) {
        if (column[i].id == 60 || column[i].id == 63) pagesize = 2;
        else pagesize = 12;
        _this.httphelper
          .post('/api/NewApi/GetGpSiteNewInfoPageList', {
            keyword: '',
            id: 0,
            parentID: 0,
            column_Type: column[i].id,
            pageIndex: 0,
            pageSize: pagesize
          })
          .then(res => {
            if (res.data.code == 200) {
              let gpSiteNewInfoViewsViews = res.data.data.gpSiteNewInfoViewsViews;
              if (gpSiteNewInfoViewsViews != null && gpSiteNewInfoViewsViews.length > 0) {
                gpSiteNewInfoViewsViews.forEach(item => {
                  if (item.cid >= 58 && item.cid <= 59) {
                    //学科动态,基地建设
                    _this.newInfotopList.push(item);
                  }
                  if (item.cid >= 61 && item.cid <= 62) {
                    //大学全科院系，青年联盟
                    _this.newInfolowerList.push(item);
                  }
                  if (item.cid == 60) {
                    //基地微对话，
                    _this.microDialogueList.push(item);
                  }
                  if (item.cid == 63) {
                    // 全科大讲堂
                    _this.generalLectureList.push(item);
                  }
                });
              }
            }
          });
      }
    },
    formatTime(datatime, timeformat) {
      return format(datatime, timeformat);
    },
    /**新闻的点击事件 */
    clkNews(info, meuntitle) {
      //如果外连接存在，跳转外链，否则跳转详情
      if (Object.keys(info.address).length == 0) {
        var param = {
          pid: 37,
          title: meuntitle,
          cid: info.cid,
          goroutename: 'disciconstruc/Inforlist'
        };
        localStorage.setItem('Inforlist_param_' + info.cid, JSON.stringify(param));
        const { href } = this.$router.resolve({
          path: '/disciconstruc/Inforlist/inforDetails?',
          query: {
            id: info.id,
            column_Type: info.cid
          }
        });
        window.open(href, '_blank');
      } else {
        window.open(info.address);
      }
    },
    // 轮播、广告图跳转外链
    // 轮播、广告图跳转外链
    Towindowurl(url) {
      if (url != null && url != '') window.open(url);
    },
    /**资讯更多 */
    onMore(cid, conetntitle) {
      this.$router.push({
        path: '/disciconstruc/Inforlist',
        query: {
          pid: 37,
          title: conetntitle,
          cid: cid
        }
      });
    }
  }
};
</script>

<style scoped>
.content {
  flex: 1;
}

.bannerWrap {
  height: 450px;
  padding-top: 40px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #dbeded, #ffffff);
}

/* 上部banner */

.topbanner {
  height: 380px;
}

.bannerleft {
  width: 930px;
  height: 380px;
  /* background: #005660; */
  box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
  border-radius: 20px 0px 0px 0px;
}

.bannerright {
  width: 299px;
  height: 380px;
  /* padding: 50px 40px; */
  box-sizing: border-box;
  position: relative;
  background: #303a60;
  box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
  border-radius: 0px 0px 20px 0px;
}

.swiper-container,
.swiper-slide {
  width: 100%;
  height: 100%;
}

.shan {
  position: absolute;
  right: 0;
  bottom: 0;
}

.bannerTitle {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 38px;
}

.bannerText {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 25px;
}

.bannerline {
  width: 40px;
  height: 1px;
  background: #ffffff;
  margin-top: 20px;
  margin-bottom: 18px;
}

.bannerBtn {
  display: inline-block;
  width: 121px;
  height: 32px;
  background: #ffffff;
  border-radius: 16px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  line-height: 32px;
  text-align: center;
}

.main {
  padding: 50px 0;
}

.mainLeft {
  width: 200px;
}

.mainRight {
  width: 300px;
}

.newsList a {
  font-size: 18px;
}

.newsList p {
  line-height: 38px;
}

.swiper-pagination {
  text-align: left;
  box-sizing: border-box;
  padding-left: 20px;
}

.setShow {
  display: none;
}

.controlShow:hover .setShow {
  display: flex;
}

.controlShow:hover .disShow {
  display: none;
}
</style>
